export default "__VITE_ASSET__CQ6dDtf1__"